var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85674 9.86204L12.853 3.84915C13.0493 3.65215 13.049 3.33319 12.852 3.13652C12.655 2.93999 12.3358 2.9405 12.1393 3.13753L6.49998 8.79251L0.860641 3.13733C0.664118 2.94032 0.345187 2.93982 0.148157 3.13631C0.0493879 3.2349 2.84464e-06 3.36407 2.83899e-06 3.49323C2.83336e-06 3.62206 0.049057 3.75071 0.14714 3.84913L6.14324 9.86204C6.23764 9.95692 6.36612 10.0102 6.49998 10.0102C6.63384 10.0102 6.76216 9.95677 6.85674 9.86204Z",
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(13) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.48c9d514f721fa6bae2944077c639729.svg";
export { ForwardRef as ReactComponent };